/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { assign } from 'lodash';

@Component({
  selector: 'gh-todo-settings-panel-control',
  template: require('./settings-panel-control.component.html'),
  styles: [require('./settings-panel-control.component.scss')],
})
export class SettingsPanelControlComponent implements OnInit {
  @Input() quantity: number = 0;
  @Input() title: string = '';
  @Input() ghIcon: string = '';
  @Input() checked: boolean = false;

  @Output() settingChanged = new EventEmitter<any>();
  private value: boolean = false;

  ngOnInit(): void {
    // iWarning(!!this.title, 'Unexpected title for SettingsPanelControlComponent.');
  }

  settingChanges(value: boolean): void {
    this.settingChanged.emit(value);
    assign(this, { value });
  }

}
